import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/solanova/Logo";
import Footer from "@/components/solanova/Footer";

export default function LegalLayout({ title, eyebrow, children, testId }) {
  return (
    <main
      data-testid={testId}
      className="bg-[var(--sol-bg)] text-white min-h-screen"
    >
      {/* slim top nav */}
      <header className="glass-nav fixed top-0 inset-x-0 z-50 py-3">
        <div className="max-w-5xl mx-auto px-6 md:px-10 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-home" aria-label="Solanova Home">
            <Logo size="sm" />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="text-sm text-white/70 hover:text-white inline-flex items-center gap-2 font-body"
          >
            <ArrowLeft size={16} /> Zur Startseite
          </Link>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-6 md:px-10 pt-40 pb-24">
        <p className="eyebrow" data-testid="legal-eyebrow">{eyebrow}</p>
        <h1 className="font-display text-4xl md:text-6xl font-extralight tracking-tight mt-6 leading-[1.05]">
          {title}
        </h1>

        <div className="prose-solanova mt-12 space-y-8 font-body text-white/75 leading-relaxed">
          {children}
        </div>

        <div className="mt-20 pt-8 border-t hairline text-xs text-white/35">
          Stand: {new Date().toLocaleDateString("de-CH", { year: "numeric", month: "long" })}
        </div>
      </article>

      <Footer />
    </main>
  );
}
